import config from 'modules/project-config.json';
import {isDevServer, isFileProtocol, isProdBuild, isTestCompany} from 'utils/env';
import {normalizeS3Url} from 'utils/s3';

export function getDataUrl(filePath: string) {
  if (!filePath.startsWith('./')) {
    throw new Error(`Invalid filePath: "${filePath}"`);
  } else if (isDevServer) {
    return filePath.replace('./', '/static/');
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const {filePaths} = window as any;
  const extRelFilePath = filePaths && filePaths[filePath];
  if (!extRelFilePath) {
    throw new Error(`Entry for file "${filePath}" not found in ./filePaths.js`);
  } else if (extRelFilePath.startsWith('https://') || extRelFilePath.startsWith('http://')) {
    return isProdBuild ? extRelFilePath : normalizeS3Url(extRelFilePath, 's3-slow');
  } else if (!extRelFilePath.startsWith('./')) {
    throw new Error(
      `Invalid file path rewrite: "${filePath}" -> "${extRelFilePath}": should start with "./" or "http[s]://"`,
    );
  } else if (filePaths && filePaths['.']) {
    const res = extRelFilePath.replace(/^.\//, `${filePaths['.']}/`);
    return isProdBuild ? res : normalizeS3Url(res, 's3-slow');
  } else if (isFileProtocol) {
    const res = extRelFilePath.replace(
      './',
      `https://yastatic.net/s3/${config.bucket}/${config.projectPath}/`,
    );
    return isProdBuild ? res : normalizeS3Url(res, 's3-slow');
  }
  const basePath = window.location.href
    .split('?')[0]
    .split('#')[0]
    .split('/')
    // eslint-disable-next-line no-nested-ternary
    .slice(0, isProdBuild ? -3 : isTestCompany ? -5 : -4)
    .join('/');
  if (basePath.split('/').length <= 3) {
    throw new Error(`Cannot get double parent to current url: "${window.location.href}"`);
  }
  const res = extRelFilePath.replace('./', `${basePath}/`);
  return isProdBuild ? res : normalizeS3Url(res, 's3-slow');
}
